import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "registered",
    "number",
    "numberGroup",
    "numberLabel",
    "numberValidationMessage",
    "jurisdiction",
    "jurisdictionGroup",
    "jurisdictionLabel"
  ];

  static defaultTaxPattern = /^(?=.*[A-Za-z])(?=.*\d).+$/;

  async connect() {
    await this.fetchTaxLabels();
    await this.fetchTaxPatterns();
    this.updateDisplay();
    this.updateJurisdiction();
  }

  async fetchTaxLabels() {
    try {
      const response = await fetch('/api/v1/tax_labels');
      if (!response.ok) throw new Error("Network response was not ok");
      this.constructor.taxLabels = await response.json();
    } catch (error) {
      this.constructor.taxLabels = {};
    }
  }

  async fetchTaxPatterns() {
    try {
      const response = await fetch('/api/v1/tax_patterns?js=true');
      if (!response.ok) throw new Error("Network response was not ok");
      const patterns = await response.json();
      this.constructor.taxPatterns = {};
      for (const [key, pattern] of Object.entries(patterns)) {
        try {
          if (pattern.endsWith('/i')) {
            const patternBody = pattern.slice(0, -2);
            this.constructor.taxPatterns[key] = new RegExp(patternBody, 'i');
          } else {
            const patternBody = pattern.startsWith('/') && pattern.endsWith('/') ?
              pattern.slice(1, -1) : pattern;
            this.constructor.taxPatterns[key] = new RegExp(patternBody);
          }
        } catch (err) {
          this.constructor.taxPatterns[key] = this.constructor.defaultTaxPattern;
        }
      }
    } catch (error) {
      this.constructor.taxPatterns = {};
    }
  }

  updateDisplay() {
    const isRegistered = this.registeredTarget.value === "true"
    this.toggleVisibility(this.numberGroupTarget, isRegistered)
    this.toggleVisibility(this.jurisdictionGroupTarget, isRegistered)
    this.toggleRequired(this.numberTarget, this.numberLabelTarget, isRegistered)
    this.toggleRequired(this.jurisdictionTarget, this.jurisdictionLabelTarget, isRegistered)
  }

  toggleVisibility(element, isVisible) {
    element.hidden = !isVisible;
  }

  toggleRequired(input, label, isRequired) {
    input.required = isRequired;
    label.textContent = isRequired
      ? `${label.textContent.trim().replace(/\s*\*$/, "")} *`
      : label.textContent.trim().replace(/\s*\*$/, "");
  }

  updateJurisdiction() {
    this.updateTaxLabel()
    this.validateTaxNumber()
  }

  updateTaxLabel() {
    const jurisdiction = this.jurisdictionTarget.value
    const taxLabel = this.constructor.taxLabels[jurisdiction] || "Tax Number"
    this.numberLabelTarget.textContent = taxLabel + (this.registeredTarget.value === "true" ? " *" : "")
  }

  validateTaxNumber() {
    const jurisdiction = this.jurisdictionTarget.value;
    const regex = this.constructor.taxPatterns[jurisdiction] || this.constructor.defaultTaxPattern;
    if (regex) {
      const isValid = regex.test(this.numberTarget.value);
      this.toggleVisibility(this.numberValidationMessageTarget, !isValid);
    } else {
      this.toggleVisibility(this.numberValidationMessageTarget, false);
    }
  }
}
